<template>
  <div>
    <p class="tip" v-if="tipFlag == true">
      温馨提示:图片仅供参考，请以实物为准
    </p>
    <van-submit-bar
      label=""
      button-color="#1E98D7"
      :price="totalAmount"
      button-text="去结算"
      @submit="onSubmit"
    >
      <van-icon
        name="shopping-cart"
        @click="cartListEvent"
        :badge="shoppingData.shoppingCarNum"
      />
    </van-submit-bar>
    <!-- 购物车弹层 -->
    <van-popup
      v-model:show="listShow"
      position="bottom"
      :style="{ height: '30%' }"
    >
      <template #default>
        <van-row style="padding: 10px; border-bottom: 1px solid #999">
          <van-col span="12"> 已选菜品 </van-col>
          <van-col span="12" align="right">
            <van-icon name="delete" />
            <span @click="empty">清空</span>
          </van-col>
        </van-row>
        <div>
          <lazy-component>
            <van-row
              style="padding: 10px"
              v-for="item in shoppingData.selectList"
              :key="item.id"
            >
              <van-col span="14">
                {{ item.name }}
              </van-col>
              <van-col span="10">
                <span style="color: #1e98d7">￥{{ item.price }}</span>
                <van-stepper
                  v-model="item.quantity"
                  input-width="20"
                  theme="round"
                  button-size="15"
                  disable-input
                  :default-value="0"
                  :min="0"
                />
              </van-col>
            </van-row>
          </lazy-component>
        </div>
      </template>
    </van-popup>
  </div>
</template>
<script setup>
import { computed, reactive, toRefs, watch } from "vue";
import { setStorage, getStorage } from "@/utils/common";
import { useRouter } from "vue-router";
const router = useRouter();
const emits = defineEmits(["cartEmpty"]);
const props = defineProps(["shoppingData", "tip"]);
const state = reactive({
  shoppingData: JSON.parse(getStorage("shoppingData")),
  listShow: false,
  totalAmount: 0,
  tipFlag: props.tip,
});
const { shoppingData, listShow, totalAmount, tipFlag } = toRefs(state);
watch(
  () => props.shoppingData,
  (val) => {
    console.log(val);
    state.shoppingData = JSON.parse(getStorage("shoppingData"));
    console.log(state.shoppingData);
  },
  {
    deep: true,
  }
);
// 价格计算
state.totalAmount = computed(() => {
  let price = 0;
  console.log(2132132);
  if (state.shoppingData.selectList.length > 0) {
    state.shoppingData.selectList.forEach((value) => {
      price += value.price * value.quantity;
    });
  }
  return price * 100;
});
const onSubmit = () => {
  // setStorage("shoppingData", JSON.stringify(state.shoppingData));
  router.push({
    name: "orderPay",
    query: { orderType: state.shoppingData.orderType },
  });
  console.log(state.shoppingData);
  console.log("去结算");
};
// 打开购物车列表
const cartListEvent = () => {
  state.listShow = !state.listShow;
};
// 清空
const empty = () => {
  state.shoppingData.selectList = [];
  state.listShow = false;
  emits("cartEmpty");
};
</script>
<style lang="scss" scoped>
.van-icon-shopping-cart {
  font-size: 40px;
}
::v-deep .van-submit-bar__text {
  text-align: left;
  padding-left: 15px;
  span {
    color: #1e98d7;
  }
}
::v-deep .van-popup--bottom {
  bottom: 71px;
}
.van-submit-bar {
  z-index: 100000;
  padding: 10px 0;
  border-top: 1px solid #000;
}
.van-stepper {
  float: right;
}
.tip {
  position: absolute;
  bottom: 81px;
  left: 10px;
  color: #aaa;
}
</style>
